import Pagination from "../../../components/Pagination/Pagination";
import "./RecentPayouts.css";
const RecentPayouts = ({ setRecentPayoutsModal }) => {
 return (
  <div className="recent-payouts-lists">
   <p className="title">18903 Results</p>

   <div className="recent-payouts-container desktop">
    <table>
     <thead>
      <tr>
       <th>TRANSACTION ID</th>
       <th>TRANSACTION TYPE</th>
       <th>AMOUNT</th>
       <th>COMMISSION</th>
       <th>DATE CREATED</th>
      </tr>
     </thead>

     <tbody>
      <tr>
       <td>RUBRWA354</td>
       <td>Payouts</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>

      <tr>
       <td>RUBRWA354</td>
       <td>Payouts</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>
      <tr>
       <td>RUBRWA354</td>

       <td>Payouts</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>
      <tr>
       <td>RUBRWA354</td>

       <td>Payouts</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>
      <tr>
       <td>RUBRWA354</td>

       <td>Payouts</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>

      <tr>
       <td>RUBRWA354</td>

       <td>Payouts</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>

      <tr>
       <td>RUBRWA354</td>

       <td>Payouts</td>
       <td>N45,000</td>
       <td>N450</td>
       <td>06-08-2021</td>
      </tr>
     </tbody>
    </table>

    <div className="pagination-wrapper">
     <Pagination />
    </div>
   </div>

   <div className="recent-payouts-container mobile">
    <div className="card" onClick={() => setRecentPayoutsModal(true)}>
     <div className="first">
      <p className="title">Mind games of a...</p>
      <p className="amount">N45,000</p>
     </div>

     <div className="second">
      <p className="description">RUBVWA354</p>
      <p className="date">06-08-2021</p>
     </div>
    </div>

    <div className="card" onClick={() => setRecentPayoutsModal(true)}>
     <div className="first">
      <p className="title">Mind games of a...</p>
      <p className="amount">N45,000</p>
     </div>

     <div className="second">
      <p className="description">RUBVWA354</p>
      <p className="date">06-08-2021</p>
     </div>
    </div>

    <div className="card">
     <div className="first">
      <p className="title">Mind games of a...</p>
      <p className="amount">N45,000</p>
     </div>

     <div className="second">
      <p className="description">RUBVWA354</p>
      <p className="date">06-08-2021</p>
     </div>
    </div>

    <div className="card">
     <div className="first">
      <p className="title">Mind games of a...</p>
      <p className="amount">N45,000</p>
     </div>

     <div className="second">
      <p className="description">RUBVWA354</p>
      <p className="date">06-08-2021</p>
     </div>
    </div>

    <div className="card">
     <div className="first">
      <p className="title">Mind games of a...</p>
      <p className="amount">N45,000</p>
     </div>

     <div className="second">
      <p className="description">RUBVWA354</p>
      <p className="date">06-08-2021</p>
     </div>
    </div>

    <div className="pagination-wrapper">
     <Pagination />
    </div>
   </div>
  </div>
 );
};

export default RecentPayouts;
